import requests from "./httpService";

const RepairPOServices = {

  // ==========================================
  // DASHBOARD - PENDING REPAIR PURCHASE ORDERS
  // ==========================================
  dashboardRepairPO: async () => {
    return requests.get("/repairpo/dashboardRepairPOData");
  },

  // ==========================================
  // GET ALL ITEMS WITH REQUEST STATUS 'PO PENDING'
  // ==========================================
  pendingPoList: async () => {
    return requests.get("/repairpo/pendingPoList");
  },

  // ==========================================
  // CREATE REPAIR PURCHASE ORDER
  // ==========================================
  CreateRepairOrder: async (data) => {
    return requests.post("/repairpo/RepairOrder", data);
  },

  // ==========================================
  // GET REPAIR PO BY STATUS
  // ==========================================
  AllPOByStatus: async (status) => {
    console.log("allposttaus", status);

    return requests.get(
      `/repairpo/PurchaseOrder/status?query=${status}`
    );
  },

  // ==========================================
  // APPROVE / SEND BACK REPAIR PO
  // ==========================================
  approvePO: async (body) => {
    return requests.post("/repairpo/approvePO", body);
  },

  // ==========================================
  // UPDATE REPAIR PO
  // ==========================================
  updatePO: async (id, data) => {
    return requests.put(
      `/repairpo/purchase-orders/${id}`,
      data
    );
  },

  // ==========================================
  // GET REPAIR PO ITEMS
  // ==========================================
  AllItemsByPoId: async (id) => {
    return requests.get(
      `/repairpo/po-items?poId=${id}`
    );
  }

};

export default RepairPOServices;